import 'bootstrap/js/src/carousel';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/button';
import 'bootstrap/js/src/offcanvas';
import './animations';
import './auto-headings-scroll';
//Change nav behaviour
window.addEventListener('load', function () {
    document.querySelectorAll('#theme-header .dropdown-toggle').forEach(function (link) {
        var dropdown = link.parentElement.querySelector('.dropdown-menu');
        link.addEventListener('mouseover', function () {
            link.classList.add('show');
            dropdown.classList.add('show');
        });
        link.addEventListener('mouseout', function (event) {
            if (event.relatedTarget === dropdown) {
                return;
            }
            link.classList.remove('show');
            dropdown.classList.remove('show');
        });
        dropdown.addEventListener('mouseover', function () {
            link.classList.add('show');
            dropdown.classList.add('show');
        });
        dropdown.addEventListener('mouseout', function (event) {
            if (event.relatedTarget === link) {
                return;
            }
            link.classList.remove('show');
            dropdown.classList.remove('show');
        });
        link.addEventListener('click', function () {
            window.location.href = link.href;
        });
    });
    var playVideo = document.querySelector('.recipe__video-play');
    var videoWrapper = document.querySelector('.recipe__video-wrapper');
    if (playVideo !== null) {
        var videoFrame_1 = document.querySelector('.recipe__video-wrapper iframe');
        playVideo.addEventListener('click', function (e) {
            e.preventDefault();
            videoWrapper.classList.add('active');
            videoFrame_1.src += "&autoplay=1&rel=0";
        });
    }
});
